import { createSelector } from 'reselect';

export const getAddWish = state => state.addWish;

export const getAddWishValue = createSelector(
  getAddWish,
  addWish => addWish.value
);



// WEBPACK FOOTER //
// ./src/store/addWish/selectors.js